import { useQuery } from '@tanstack/react-query';
import Organization from '@/types/organizationType';
import {
  fetchOrganizationByName,
  fetchOrganizationByUUID,
} from '@/apis/fetchOrganization';

export const useOrganizationByName = (orgName: string) => {
  return useQuery<Organization>({
    queryKey: ['organization', 'byName', orgName],
    queryFn: async () => {
      const organization = await fetchOrganizationByName(orgName);
      return organization;
    },
    enabled: !!orgName && orgName !== '',
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

export const useOrganizationByUUID = (uuid: string) => {
  return useQuery<{ Org: Organization }>({
    queryKey: ['organization', 'byUUID', uuid],
    queryFn: async () => {
      const response = await fetchOrganizationByUUID(uuid);
      return response;
    },
    enabled: !!uuid && uuid !== '',
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
